import { localStorageService } from 'services/localStorage';

import type { User, AuthMethodsType } from '../../types/generic-context';

interface ISignIn {
  user?: User;
  token?: string;
  authTypes?: AuthMethodsType[];
}

// eslint-disable-next-line import/no-default-export
export default class AuthService {
  signIn(body: ISignIn) {
    const { user, token, authTypes } = body;

    if (user) {
      localStorageService.user = user;
    }

    if (user && user.firstName) {
      localStorageService.firstName = user.firstName;
    }

    if (token) {
      localStorageService.token = token;
    }

    if (authTypes) {
      localStorageService.authTypes = authTypes;
    }
  }
}
